var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99988 2.5V1.25H6.24988V2.5H9.99988ZM11.2499 2.5V0.625C11.2499 0.28 10.9699 0 10.6249 0H5.62488C5.27988 0 4.99988 0.28 4.99988 0.625V2.5H1.875H0.625C0.28 2.5 0 2.78 0 3.125C0 3.47 0.28 3.75 0.625 3.75H1.25V18.125C1.25 19.1588 2.09125 20 3.125 20H13.125C14.1588 20 15 19.1588 15 18.125V3.75H15.625C15.97 3.75 16.25 3.47 16.25 3.125C16.25 2.78 15.97 2.5 15.625 2.5H14.375H11.2499ZM13.75 3.75H10.6249H5.62488H2.5V18.125C2.5 18.47 2.78125 18.75 3.125 18.75H13.125C13.4688 18.75 13.75 18.47 13.75 18.125V3.75ZM5 15.625C5 15.97 5.28 16.25 5.625 16.25C5.97 16.25 6.25 15.97 6.25 15.625V6.875C6.25 6.53 5.97 6.25 5.625 6.25C5.28 6.25 5 6.53 5 6.875V15.625ZM8.125 16.25C7.78 16.25 7.5 15.97 7.5 15.625V6.875C7.5 6.53 7.78 6.25 8.125 6.25C8.47 6.25 8.75 6.53 8.75 6.875V15.625C8.75 15.97 8.47 16.25 8.125 16.25ZM10 15.625C10 15.97 10.28 16.25 10.625 16.25C10.97 16.25 11.25 15.97 11.25 15.625V6.875C11.25 6.53 10.97 6.25 10.625 6.25C10.28 6.25 10 6.53 10 6.875V15.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.1cf95d1c4ef8d3d930ada3dd5ef8eb9c.svg";
export { ForwardRef as ReactComponent };